class QueueNode<T> {
  next: QueueNode<T> | undefined = undefined;
  prev: QueueNode<T> | undefined = undefined;

  constructor(readonly value: T) {}
}

export class EmptyError extends Error {
  constructor() {
    super("Empty");
  }
}

/**
 * FIFO queue
 */
export class Queue<T> {
  #back: QueueNode<T> | undefined;
  #front: QueueNode<T> | undefined;

  empty() {
    return !this.#front;
  }

  pop(): T {
    if (!this.#front) {
      throw new EmptyError();
    }
    const result = this.#front;
    this.#front = result.prev;
    if (this.#front) {
      this.#front.next = undefined;
    } else {
      this.#back = undefined;
    }
    result.prev = undefined;
    result.next = undefined;
    return result.value;
  }

  push(item: T): () => void {
    const node = new QueueNode(item);
    node.next = this.#back;
    if (this.#back) {
      this.#back.prev = node;
    } else {
      this.#front = node;
    }
    this.#back = node;
    return () => {
      if (node.prev) {
        node.prev.next = node.next;
      } else if (this.#back === node) {
        this.#back = node.next;
      }
      if (node.next) {
        node.next.prev = node.prev;
      } else if (this.#front === node) {
        this.#front = node.prev;
      }
      node.prev = undefined;
      node.next = undefined;
    };
  }
}
